const MS_PER_DAY = 24 * 60 * 60 * 1000;

function toValidDate(value) {
    if (!value) return null;
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function getCalendarDayNumber(value, timeZone) {
    const date = toValidDate(value);
    if (!date) return null;

    if (!timeZone) {
        return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / MS_PER_DAY;
    }

    const parts = new Intl.DateTimeFormat("en-US", {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).formatToParts(date);
    const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
    return Date.UTC(
        Number(values.year),
        Number(values.month) - 1,
        Number(values.day)
    ) / MS_PER_DAY;
}

export function isRecentActivityDate(value, range, { now = new Date(), timeZone } = {}) {
    const activityDay = getCalendarDayNumber(value, timeZone);
    const currentDay = getCalendarDayNumber(now, timeZone);
    if (activityDay === null || currentDay === null) return false;

    if (range === "today") return activityDay === currentDay;

    const currentWeekday = new Date(currentDay * MS_PER_DAY).getUTCDay();
    const daysSinceMonday = currentWeekday === 0 ? 6 : currentWeekday - 1;
    return activityDay >= currentDay - daysSinceMonday && activityDay <= currentDay;
}

export function getPatientActivityDate(patient) {
    if (patient?.lastSeenAt) return patient.lastSeenAt;

    // Mixed-version fallback while v1 summaries are backfilled. Version 2 has
    // an explicit lastSeenAt and must not silently fall back to clinical dates.
    if ((patient?._summary?.version || 0) < 2) {
        const latest = patient?.latestDocument;
        const status = String(latest?.status || "").trim().toLowerCase();
        if ((status === "complete" || status === "completed") && latest?.createdAt) {
            return latest.createdAt;
        }
    }

    return null;
}

export function filterRecentlySeenPatients(patients, range, options) {
    return (patients || [])
        .map((patient) => {
            const lastSeenAt = getPatientActivityDate(patient);
            if (!isRecentActivityDate(lastSeenAt, range, options)) return null;
            return { ...patient, _lastSeenDate: lastSeenAt };
        })
        .filter(Boolean);
}
